// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Expand: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
<g>
	<rect x="11.33" y="-0.16" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.9838 12.0317)" width="1.4" height="24.37"/>
	<polygon points="23.7,23.7 15.89,23.7 15.89,22.3 22.3,22.3 22.3,15.89 23.7,15.89 	"/>
	<polygon points="1.7,8.11 0.3,8.11 0.3,0.3 8.11,0.3 8.11,1.7 1.7,1.7 	"/>
</g>
</svg>;
};

export default React.memo(Expand);
